export const IMPACT_CONFIG = {
  critical: { color: "#dc2626", bg: "#fef2f2", label: "Critical" },
  serious: { color: "#d97706", bg: "#fffbeb", label: "Serious" },
  moderate: { color: "#2563eb", bg: "#eff6ff", label: "Moderate" },
  minor: { color: "#4b5563", bg: "#f9fafb", label: "Minor" }
} as const;

export type Impact = keyof typeof IMPACT_CONFIG;

export function getScoreColor(score: number): string {
  if (score >= 90) return "#16a34a";
  if (score >= 70) return "#d97706";
  return "#dc2626";
}
